import * as React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ButtonType } from '@/components/atoms/button'
import { FrontTabletButton } from '../button'
import { css } from '@emotion/core'
import { SupportQr } from '@/components/organisms/self-checkin/payment/support-qr'
import { SelfCheckOutState } from '@/models/self-checkout'
import { CASH, CREDIT_CARD } from '@/models/payment-method'

export type Props = {
  state: SelfCheckOutState
  onCredit: () => void
  onCreditForm: () => void
  onUnionPay: () => void
  onQR: () => void
  onCashChanger: () => void
  onFront: () => void
}

export const SelectablePaymentMethod: React.FC<Props> = props => {
  const { t } = useTranslation()

  const showCashButton =
    // 釣銭機がある、またはis_enabled_cashがtrue または、釣銭機ないがスマート決済（現金）が有効の場合は、現金払いボタンを有効
    props.state.setting.isEnabledCashChanger ||
    props.state.setting.paymentTerminal.isEnabledCash ||
    (!props.state.setting.isEnabledCashChanger && props.state.setting.payment.includes(CASH))

  return (
    <div css={componentStyle}>
      {props.state.setting.isEnabledPaymentTerminal ? (
        <>
          <FrontTabletButton
            buttonType={ButtonType.Primary}
            width={showCashButton && props.state.setting.paymentTerminal.isEnabledQr ? 'calc(50% - 8px)' : '100%'}
            shape="square"
            onClick={props.onCredit}
          >
            {t('Credit Card')}
          </FrontTabletButton>
          <FrontTabletButton buttonType={ButtonType.Primary} width="calc(50% - 8px)" shape="square" onClick={props.onUnionPay}>
            {t('UnionPay')}
          </FrontTabletButton>
          {props.state.setting.paymentTerminal.isEnabledQr && (
            <FrontTabletButton buttonType={ButtonType.Primary} width="calc(50% - 8px)" shape="square" onClick={props.onQR}>
              {t('QR Payment')}
            </FrontTabletButton>
          )}
        </>
      ) : (
        props.state.setting.payment.includes(CREDIT_CARD) && (
          <FrontTabletButton buttonType={ButtonType.Primary} width={'100%'} shape="square" onClick={props.onCreditForm}>
            {t('Credit Card')}
          </FrontTabletButton>
        )
      )}
      {showCashButton &&
        (props.state.setting.isEnabledCashChanger ? (
          <FrontTabletButton
            buttonType={ButtonType.Primary}
            width={props.state.setting.isEnabledPaymentTerminal ? 'calc(50% - 8px)' : '100%'}
            shape="square"
            onClick={props.onCashChanger}
          >
            <Trans i18nKey="Cash" />
          </FrontTabletButton>
        ) : (
          <FrontTabletButton
            buttonType={ButtonType.Primary}
            width={props.state.setting.isEnabledPaymentTerminal ? 'calc(50% - 8px)' : '100%'}
            shape="square"
            onClick={props.onFront}
            customCss={{
              wordBreak: 'keep-all',
              overflowWrap: 'break-word',
            }}
          >
            <Trans i18nKey="Cash payment at front desk" />
          </FrontTabletButton>
        ))}
      {props.state.setting.isEnabledPaymentTerminal && (
        <div>
          <div className="credit-block">
            <div className="payment-title">{t('Supported Credits')}</div>
            <img src={require('@/static/images/self-checkin-payment/terminal/logo_card01.png')} />
          </div>
          {props.state.setting.paymentTerminal.isEnabledQr && <SupportQr className="brand-image-block" />}
        </div>
      )}
    </div>
  )
}

const componentStyle = css({
  display: 'flex',
  gap: 16,
  flexWrap: 'wrap',
  '.payment-title': {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    letterSpacing: 1.8,
    color: '#676767',
    paddingTop: 8,
    lineHeight: 1.5,
  },
  '.brand-image-block': { marginTop: 8 },
  '.credit-block': {
    marginTop: 22,
    border: '1px solid #CCCCCC',
    borderRadius: 10,
    img: {
      width: '100%',
      padding: '14px 8px',
    },
  },
})
